import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs/Observable';

/*
  Generated class for the VotingProvider provider.

  See https://angular.io/guide/dependency-injection for more info on providers
  and Angular DI.
*/
@Injectable()
export class VotingProvider {

  constructor(public http: HttpClient) {
    console.log('Hello VotingProvider Provider');
  }

  getActiveEvent
  getActiveQuestions(pin): Observable<any> {
    return this.http.get('https://www.votingstudio.com/api/Question/GetVoterActiveQuestion?pin=' + pin);
  }

  postVote(answerId): Observable<any> {
    return this.http.post('https://www.votingstudio.com/api/EventVoting/PostVote', answerId);
  }
  

}



// WEBPACK FOOTER //
// ./src/providers/voting/voting.ts